import React, { useState, useEffect } from "react";
import { styled } from "@mui/styles";
import { Box, Stack, Grid, Slider } from "@mui/material";
import VSNTypography from "../../../shared/VSNTypography";
import useOTBStyle from "../OTBStyle";

const AbnormalLabs = ({ data, pdf }) => {
  const classes = useOTBStyle();

  const visceralFatValues = data?.map((patient) => patient.visceral_fat);
  const numericValues = visceralFatValues.map(Number);
  const visceralMAX = Math.max(...numericValues) ?? 0;
  const visceralMIN = Math.min(...numericValues) ?? 0;
  const [visceralFat, setVisceralFat] = useState([visceralMIN, visceralMAX]);

  const BodyFatValues = data?.map((patient) => patient.body_fat_percentage);
  const bodyNumericValues = BodyFatValues.map(Number);
  const bodyFatMAX = Math.max(...bodyNumericValues) ?? 0;
  const bodyFatMIN = Math.min(...bodyNumericValues) ?? 0;
  const [bodyFat, setBodyFat] = useState([bodyFatMIN, bodyFatMAX]);

  useEffect(() => {
    setVisceralFat([visceralMIN, visceralMAX]);
  }, [visceralMIN, visceralMAX]);

  useEffect(() => {
    setBodyFat([bodyFatMIN, bodyFatMAX]);
  }, [bodyFatMIN, bodyFatMAX]);

  const handleChange1 = (event, newValue) => {
    setVisceralFat(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setBodyFat(newValue);
  };

  const filterByVisceralFat = data.filter(
    (patient) =>
      patient.visceral_fat >= visceralFat[0] &&
      patient.visceral_fat <= visceralFat[1]
  );

  const filterByBodyFat = filterByVisceralFat.filter(
    (patient) =>
      patient.body_fat_percentage >= bodyFat[0] &&
      patient.body_fat_percentage <= bodyFat[1]
  );

  return (
    <Box>
      {pdf && (
        <Box
          className={classes.pdfReportLayout}
          sx={{ pageBreakAfter: "always" }}
        >
          <VSNTypography variant="h4">Abnormal Labs</VSNTypography>
          <Box>
            {/* <Stack
            direction="row"
            alignItems="center"
            justifyContent="end"
            spacing={3}
            sx={{ marginBottom: "32px" }}
          >
            <Stack
              spacing={1}
              sx={{
                padding: "20px",
                backgroundColor: "#F1E1CD",
                borderRadius: "12px",
                width: "300px",
              }}
            >
              <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Box>
                  <VSNTypography
                    variant="h6"
                    sx={{
                      cursor: "pointer",
                      fontWeight: 600,
                      color: "#0A0A0B",
                      lineHeight: "31.5px",
                    }}
                  >
                    Visceral Fat
                  </VSNTypography>
                  <VSNTypography
                    variant="body2"
                    sx={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#6E7079",
                      lineHeight: "23.44px",
                    }}
                  >
                    Low ({visceralMIN}) - High ({visceralMAX})
                  </VSNTypography>
                </Box>
                <VSNTypography fontWeight={600} sx={{ fontSize: "30px" }}>
                  {data?.filter(({ vitals }) => vitals === 1)?.length}
                </VSNTypography>
              </Stack>
              <Box
                sx={{
                  ".MuiSlider-track": {
                    backgroundColor: "#B29263",
                  },
                }}
              >
                <Slider
                  value={visceralFat}
                  onChange={handleChange1}
                  valueLabelDisplay="auto"
                  min={visceralMIN}
                  max={visceralMAX}
                />
              </Box>
            </Stack>

            <Stack
              spacing={1}
              sx={{
                padding: "20px",
                backgroundColor: "#F1E1CD",
                borderRadius: "12px",
                width: "300px",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Box>
                  <VSNTypography
                    variant="h6"
                    sx={{
                      cursor: "pointer",
                      fontWeight: 600,
                      color: "#0A0A0B",
                      lineHeight: "31.5px",
                    }}
                  >
                    Body Fat %
                  </VSNTypography>
                  <VSNTypography
                    variant="body2"
                    sx={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#6E7079",
                      lineHeight: "23.44px",
                    }}
                  >
                    Ideal: Male-15% Female-27%
                  </VSNTypography>
                </Box>
                <VSNTypography fontWeight={600} sx={{ fontSize: "30px" }}>
                  {data?.filter(({ vitals }) => vitals === 1)?.length}
                </VSNTypography>
              </Stack>
              <Box
                sx={{
                  ".MuiSlider-track": {
                    backgroundColor: "#B29263",
                  },
                }}
              >
                <Slider
                  value={bodyFat}
                  onChange={handleChange2}
                  valueLabelDisplay="auto"
                  min={bodyFatMIN}
                  max={bodyFatMAX}
                />
              </Box>
            </Stack>
          </Stack> */}

            <Stack gap={2}>
              <Stack direction="row" gap={2}>
                <PDFLabCard
                  title="Cholesterol"
                  subtext="Greater than 199 MG/DL"
                  value={
                    filterByBodyFat.filter((p) => p.cholestrol === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.cholestrol === null)?.length
                  }
                />
                <PDFLabCard
                  title="Triglycerides"
                  subtext="Greater than 150 MG/DL"
                  value={
                    filterByBodyFat.filter((p) => p.triglycerides === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.triglycerides === null)
                      ?.length
                  }
                />
                <PDFLabCard
                  title="HDL"
                  subtext="Less than 39 MG/DL"
                  value={filterByBodyFat.filter((p) => p.hdl === 0).length}
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hdl === null)?.length
                  }
                />
                <PDFLabCard
                  title="Calculated LDL"
                  subtext="Calc LDL-AB"
                  value={
                    filterByBodyFat.filter((p) => p.calculated_hdl === 0)
                      ?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.calculated_hdl === null)
                      ?.length
                  }
                />
              </Stack>

              <Stack direction="row" gap={2}>
                <PDFLabCard
                  title="Hemoglobin"
                  superSubText="Outside Reference Range:"
                  subtext="Male (13.5 -17) Female (11.5-15.5)"
                  value={
                    filterByBodyFat.filter((p) => p.hemoglobin === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hemoglobin === null)?.length
                  }
                />
                <PDFLabCard
                  title="Hematocrit"
                  superSubText="Outside Reference Range:"
                  subtext="Male (40 - 51 ) Female (34 - 45)"
                  value={
                    filterByBodyFat.filter((p) => p.hematocrit === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hematocrit === null)?.length
                  }
                />

                <PDFLabCard
                  title="Hemoglobin & Hematocrit"
                  superSubText="Outside Reference Range:"
                  subtext="Male(40 - 51) Female(34 - 45)"
                  value={
                    filterByBodyFat.filter(
                      (p) => p.hemoglobin_and_hematocrit === 0
                    ).length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter(
                      (p) => p.hemoglobin_and_hematocrit === null
                    )?.length
                  }
                />

                <PDFLabCard
                  title="Thyroid Stimulating Hormone"
                  subtext="0.4 < TSH < 4.1"
                  value={
                    filterByBodyFat.filter(
                      (p) => p.thyroid_stimulating_hormone === 1
                    ).length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter(
                      (p) => p.thyroid_stimulating_hormone === null
                    )?.length
                  }
                />
              </Stack>

              <Stack direction="row" gap={2}>
                <PDFLabCard
                  title="Free T4 (Thyroxine)"
                  subtext="0.8 < T4 < 1.9"
                  value={filterByBodyFat.filter((p) => p.free_t4 === 1).length}
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.free_t4 === null)?.length
                  }
                />
                <PDFLabCard
                  title="Cortisol"
                  subtext="4.8 < Cortisol < 19.5"
                  value={filterByBodyFat.filter((p) => p.cortisol === 1).length}
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.cortisol === null)?.length
                  }
                />
                <PDFLabCard
                  title="Total Testosterone"
                  subtext="300 < Testosterone < 700"
                  value={
                    filterByBodyFat.filter((p) => p.total_testosterone === 1)
                      .length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.total_testosterone === null)
                      ?.length
                  }
                />
                <PDFLabCard
                  title="Free Testosterone (calc.)"
                  subtext="47 < Free Test < 244"
                  value={
                    filterByBodyFat.filter((p) => p.free_testosterone === 1)
                      .length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.free_testosterone === null)
                      ?.length
                  }
                />
              </Stack>
            </Stack>
          </Box>
        </Box>
      )}

      {!pdf && (
        <Box>
          <Box className={classes.reportLayout}>
            <div className={classes.stickyTitle}>
              <VSNTypography variant="h2">Abnormal Labs</VSNTypography>
            </div>
            <Box>
              <Stack
                direction={{ sm: "row" }}
                alignItems="center"
                justifyContent="end"
                spacing={3}
                sx={{ marginBottom: "32px" }}
              >
                <Stack
                  spacing={2}
                  sx={{
                    backgroundColor: "#F1E1CD",
                    borderRadius: "12px",
                    maxWidth: { sm: 355 },
                    width: "100%",
                  }}
                  p={2}
                  mb={{ sm: 0, xs: 3 }}
                >
                  <Stack
                    direction="row"
                    spacing={3}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box flex={1}>
                      <VSNTypography
                        variant="h6"
                        sx={{
                          cursor: "pointer",
                          fontWeight: 700,
                          color: "#0A0A0B",
                          lineHeight: "31.5px",
                        }}
                      >
                        Visceral Fat
                      </VSNTypography>
                      <VSNTypography
                        variant="body2"
                        sx={{
                          cursor: "pointer",
                          fontSize: "18px",
                          fontWeight: 500,
                          color: "#6E7079",
                          lineHeight: "23.44px",
                        }}
                      >
                        Low ({visceralMIN}) - High ({visceralMAX})
                      </VSNTypography>
                    </Box>
                    <VSNTypography
                      component="h4"
                      variant="h4"
                      sx={{ fontSize: "40px" }}
                    >
                      {data?.filter(({ vitals }) => vitals === 1)?.length}
                    </VSNTypography>
                  </Stack>
                  <Box>
                    <Slider
                      value={visceralFat}
                      onChange={handleChange1}
                      valueLabelDisplay="auto"
                      color="natural"
                      min={visceralMIN}
                      max={visceralMAX}
                    />
                  </Box>
                </Stack>
                <Stack
                  spacing={2}
                  sx={{
                    backgroundColor: "#F1E1CD",
                    borderRadius: "12px",
                    maxWidth: { sm: 355 },
                    width: "100%",
                  }}
                  p={2}
                >
                  <Stack
                    direction="row"
                    spacing={3}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box flex={1}>
                      <VSNTypography
                        variant="h6"
                        sx={{
                          cursor: "pointer",
                          fontWeight: 700,
                          color: "#0A0A0B",
                          lineHeight: "31.5px",
                        }}
                      >
                        Body Fat %
                      </VSNTypography>
                      <VSNTypography
                        variant="body2"
                        sx={{
                          cursor: "pointer",
                          fontSize: "18px",
                          fontWeight: 500,
                          color: "#6E7079",
                          lineHeight: "23.44px",
                        }}
                      >
                        Ideal: Male-15% Female-27%
                      </VSNTypography>
                    </Box>
                    <VSNTypography
                      component="h4"
                      variant="h4"
                      sx={{ fontSize: "40px" }}
                    >
                      {data?.filter(({ vitals }) => vitals === 1)?.length}
                    </VSNTypography>
                  </Stack>
                  <Box>
                    <Slider
                      value={bodyFat}
                      onChange={handleChange2}
                      valueLabelDisplay="auto"
                      color="natural"
                      min={bodyFatMIN}
                      max={bodyFatMAX}
                    />
                  </Box>
                </Stack>
              </Stack>

              <Grid container spacing={{ xl: 3, xs: 2 }}>
                <LabCard
                  title="Cholesterol"
                  subtext="Greater than 199 MG/DL"
                  value={
                    filterByBodyFat.filter((p) => p.cholestrol === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.cholestrol === null)?.length
                  }
                />
                <LabCard
                  title="Triglycerides"
                  subtext="Greater than 150 MG/DL"
                  value={
                    filterByBodyFat.filter((p) => p.triglycerides === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.triglycerides === null)
                      ?.length
                  }
                />
                <LabCard
                  title="HDL"
                  subtext="Less than 39 MG/DL"
                  value={filterByBodyFat.filter((p) => p.hdl === 0)?.length}
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hdl === null)?.length
                  }
                />
                <LabCard
                  title="Calculated LDL"
                  subtext="Calc LDL-AB"
                  value={
                    filterByBodyFat.filter((p) => p.calculated_hdl === 0)
                      ?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.calculated_hdl === null)
                      ?.length
                  }
                />

                <LabCard
                  title="Hemoglobin"
                  superSubText="Outside Reference Range:"
                  subtext="Male (13.5 -17) Female (11.5-15.5)"
                  value={
                    filterByBodyFat.filter((p) => p.hemoglobin === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hemoglobin === null)?.length
                  }
                />
                <LabCard
                  title="Hematocrit"
                  superSubText="Outside Reference Range:"
                  subtext="Male (40 - 51 ) Female (34 - 45)"
                  value={
                    filterByBodyFat.filter((p) => p.hematocrit === 0)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.hematocrit === null)?.length
                  }
                />
                <LabCard
                  title="Hemoglobin & Hematocrit"
                  superSubText="Outside Reference Range:"
                  subtext="Male(40 - 51) Female(34 - 45)"
                  value={
                    filterByBodyFat.filter(
                      (p) => p.hemoglobin_and_hematocrit === 0
                    )?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter(
                      (p) => p.hemoglobin_and_hematocrit === null
                    )?.length
                  }
                />
                <LabCard
                  title="Thyroid Stimulating Hormone"
                  subtext="0.4 < TSH < 4.1"
                  value={
                    filterByBodyFat.filter(
                      (p) => p.thyroid_stimulating_hormone === 1
                    ).length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter(
                      (p) => p.thyroid_stimulating_hormone === null
                    )?.length
                  }
                />
                <LabCard
                  title="Free T4 (Thyroxine)"
                  subtext="0.8 < T4 < 1.9"
                  value={filterByBodyFat.filter((p) => p.free_t4 === 1)?.length}
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.free_t4 === null)?.length
                  }
                />

                <LabCard
                  title="Cortisol"
                  subtext="4.8 < Cortisol < 19.5"
                  value={
                    filterByBodyFat.filter((p) => p.cortisol === 1)?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.cortisol === null)?.length
                  }
                />
                <LabCard
                  title="Total Testosterone"
                  subtext="300 < Testosterone < 700"
                  value={
                    filterByBodyFat.filter((p) => p.total_testosterone === 1)
                      ?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.total_testosterone === null)
                      ?.length
                  }
                />
                <LabCard
                  title="Free Testosterone (calc.)"
                  subtext="47 < Free Test < 244"
                  value={
                    filterByBodyFat.filter((p) => p.free_testosterone === 1)
                      ?.length
                  }
                  total={filterByBodyFat.length}
                  totalData={data?.length}
                  nullValue={
                    filterByBodyFat.filter((p) => p.free_testosterone === null)
                      ?.length
                  }
                />
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export const LabCard = ({
  title,
  subtext,
  value,
  total,
  totalData,
  nullValue = 0,
  superSubText,
}) => {
  const CardStyled = styled(Stack)(({ theme }) => ({
    padding: 20,
    background: "var(--white)",
    boxShadow: "0px 0px 16px 0px #00000014",
    borderRadius: "16px",
    [theme.breakpoints.down("xl")]: { padding: 10 },
    "& .MuiTypography-h4": {
      fontSize: 22,
      fontWeight: 500,
      color: "#202024",
      marginBottom: 5,
      [theme.breakpoints.down("xl")]: {
        fontSize: 15,
      },
    },
    "& .MuiTypography-h5": {
      fontSize: 18,
      fontWeight: 500,
      lineHeight: "30px",
      color: "#898994",
      [theme.breakpoints.down("xl")]: {
        fontSize: 14,
      },
    },
    "& .MuiTypography-h3": {
      fontWeight: 700,
      color: "#000000",
      "& span": {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: "22px",
        color: "var(--gray)",
      },
    },
  }));
  return (
    <Grid item md={3} smd={6} xs={12}>
      <CardStyled>
        <VSNTypography component="h4" variant="h4">
          {title}
        </VSNTypography>
        {superSubText && (
          <VSNTypography sx={{ marginTop: "-4px", color: "var(--gray)" }}>
            {superSubText}
          </VSNTypography>
        )}
        <VSNTypography component="h5" variant="h5">
          {subtext}
        </VSNTypography>
        <VSNTypography component="h3" variant="h3">
          {value} / {totalData}{" "}
          <span
            style={{
              color: nullValue > 0 ? "red" : "green",
            }}
          >
            {" "}
            ({nullValue > 0 ? `-${nullValue}` : 0})
          </span>
        </VSNTypography>
      </CardStyled>
    </Grid>
  );
};

export const PDFLabCard = ({
  title,
  subtext,
  value,
  total,
  totalData,
  nullValue = 0,
  superSubText,
}) => {
  const classes = useOTBStyle();
  return (
    <Box className={classes.pdfReportCard}>
      <VSNTypography variant="h2">{title}</VSNTypography>
      {superSubText && (
        <VSNTypography
          sx={{
            marginTop: "-4px !important",
            color: "var(--gray)",
            fontSize: "10px !important",
          }}
        >
          {superSubText}
        </VSNTypography>
      )}
      <VSNTypography variant="h3">{subtext}</VSNTypography>

      <VSNTypography className="record" sx={{ marginTop: "0 !important" }}>
        {value} / {totalData}{" "}
        <span
          style={{
            color: nullValue > 0 ? "red" : "green",
          }}
        >
          {" "}
          ({nullValue > 0 ? `-${nullValue}` : 0})
        </span>
      </VSNTypography>
    </Box>
  );
};

export default AbnormalLabs;
